import { useState } from "react";
import { useCompareV2Selector } from "../redux/store";
import { spaceAndRoomCategoryCodes, engineCategoryCodes } from "../utils/constants";
import type { SpecItemType } from "../../../common-deprecated/features/compare/utils/newCarCompareTypes";

type useEngineSpecReturnType = {
    availableEngineSpecs: SpecItemType[];
    additionalEngineSpecs: SpecItemType[];
    openAllSpecsEngines: boolean;
    setOpenAllSpecsEngines: (val: boolean) => void;
};

const useEngineSpecs = (isPdf?: boolean): useEngineSpecReturnType => {
    const specs = useCompareV2Selector((state) => state.newCarCompare.parsedSpecs);
    const [openAllSpecsEngines, setOpenAllSpecsEngines] = useState<boolean>(isPdf || false);

    const availableEngineSpecs = specs.filter((spec) => engineCategoryCodes.includes(spec.categoryCode.toUpperCase()));
    const additionalEngineSpecs = specs.filter(
        (spec) => !spaceAndRoomCategoryCodes.concat(engineCategoryCodes).includes(spec.categoryCode.toUpperCase()),
    );

    return {
        availableEngineSpecs,
        additionalEngineSpecs,
        openAllSpecsEngines,
        setOpenAllSpecsEngines: (val: boolean) => setOpenAllSpecsEngines(val),
    };
};

export default useEngineSpecs;
